module.exports = __webpack_public_path__ + "static/media/no.368ae8f6.svg";